import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { useCountdown } from "../hooks/useCountdown";

const Hero = ({ onShowInterest }) => {
  const { ref, inView } = useScrollAnimation({ threshold: 0.3 });

  const launchDate = "2026-04-13T00:00:00";
  const countdown = useCountdown(launchDate);

  return (
    <section id="home" className="hero-section">
      <Container>
        <Row className="align-items-end g-2">
          {/* Left Content */}
          <Col lg={8} className="hero-content">
            <div
              ref={ref}
              className={`animate-on-scroll fade-in-up ${inView ? 'visible' : ''}`}
            >
              <h1 className="hero-title">
                Rooted in faith, Designed for a lifetime of wellness
              </h1>

              <p className="hero-description">
                A private menstrual and spiritual wellness tracker for Muslim women—designed around your cycle, prayers, and faith.
              </p>

              <div className="hero-buttons">
                <Button
                  className="btn-show-interest"
                  onClick={onShowInterest}
                >
                  Show interest
                </Button>
                <Button
                  className="btn-learn-more d-none d-lg-block"
                  onClick={() => {
                    const element = document.getElementById('features');
                    if (element) {
                      const offsetTop = element.offsetTop - 120;
                      window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                      });
                    }
                  }}
                >
                  Learn More
                </Button>
              </div>

              <div className="launch-countdown">
                {countdown ? (
                  <span className="countdown-text">
                    Launch Day: {countdown.days} Days{" "}
                    {countdown.hours} Hours{" "}
                    {countdown.minutes} Mins{" "}
                    {countdown.seconds} Secs
                  </span>
                ) : (
                  <span className="countdown-text">
                    🚀 We are Live!
                  </span>
                )}
              </div>
            </div>
          </Col>

          {/* Right Phone Mockup */}
          <Col lg={4} className="hero-phone">
            <div className={`phone-mockup-container animate-on-scroll scale-in ${inView ? 'visible' : ''}`}>
              <img
                src="/images/phone-mockup.svg"
                alt="Nisa Care App Interface"
                className="phone-image"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;